module.exports = __webpack_public_path__ + "img/background_pattern.8c644627.png";